// extracted by mini-css-extract-plugin
export default {"SearchBar":"RecentlyView_SearchBar__HGYIV","Content":"RecentlyView_Content__ggOqu"};